import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");
export const extractStammdatenAction = factory<ExtractStammdatenPayload>("EXTRACT_STAMMDATEN");

export const openStammdatenAction = factory<OpenStammdatenPayload>("OPEN_STAMMDATEN");

export interface ExtractStammdatenPayload {
	readonly fachverfahrenDocRef: string;
	readonly fachverfahrenId: string;
	readonly activityId: string;
}

export interface OpenStammdatenPayload {
	readonly docRef: string;
	readonly initiatingActivityId?: string;
}

const crudFactory = actionCreatorFactory("CRUD");

export const createNewDocument = crudFactory<CreateNewDocumentPayload>("CREATE_NEW_DOCUMENT");

export const selectRow = crudFactory<SelectRowPayload>("SELECT_ROW");

export interface CreateNewDocumentPayload {
	readonly activityId: string;
	readonly childActivityId?: string;
	readonly appId: string;
	readonly model: string;
	readonly key: string;
	readonly client?: string;
}

interface SelectRowPayload {
	readonly activityId: string;
	readonly modelId: string;
	readonly instanceId: string;
}
